<template>
  <div class="flex flex-wrap gap-2">
    <JoszakiPill
      v-if="question.profession"
      :to="
        localePath({
          name: 'professionQuestions',
          params: { profession: question.profession.seoName },
        })
      "
      component="NuxtLink"
      @click="$trackers.trackClick('CardQuestionProfession')"
    >
      {{ question.profession.name }}
    </JoszakiPill>
    <JoszakiPill
      v-if="question.professionTask"
      :inverted="true"
      :to="
        localePath({
          name: 'professionTaskQuestions',
          params: { professionTask: question.professionTask.seoName },
        })
      "
      component="NuxtLink"
      @click="$trackers.trackClick('CardQuestionProfessionTask')"
    >
      {{ question.professionTask.name }}
    </JoszakiPill>
  </div>
</template>

<script>
export default {
  name: "QuestionPills",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
};
</script>
